import React, { ReactElement } from 'react'
import { BoxProps } from '@mindfulchefuk/design-system/layout/Box'
import { Svg } from '@mindfulchefuk/design-system'

const Maestro = (props: BoxProps): ReactElement => (
  <Svg viewBox="0 0 26 16" {...props}>
    <rect width="26" height="16" rx="2" ry="2" fill="#313159" />
    <circle cx="10.09" cy="8" r="4.36" fill="#d92e28" />
    <circle
      data-name="Ellipse 8 copy"
      cx="15.91"
      cy="8"
      r="4.36"
      fill="#4299da"
    />
    <path
      data-name="Rounded Rectangle 25"
      d="M13 4.36a4.12 4.12 0 00-1.71 5.56 4 4 0 001.22 1.4l.49.32h.05a4.09 4.09 0 001.67-5.53A4.19 4.19 0 0013 4.36"
      fill="#6c6db9"
    />
  </Svg>
)

export default Maestro
